export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13940.92bb3436.jpg";